import Loading from '@/components/common/Loading'
import dynamic from 'next/dynamic'
import Head from 'next/head'
import SchemaTags from "@/components/common/SchemaTags";
import React from 'react'


const Desktop = dynamic(() => import("@/components/outlet/DesktopKidsPlayArea"), {
    loading: () => <Loading />
})

const Mobile = dynamic(() => import("@/components/outlet/MobileKidsPlayArea"), {
    loading: () => <Loading />
})


const kidsPlayArea = ({ mobileView }) => {
    return (
        <>
            <Head>
                <title>Kids Play Area Billing Software | POS System for Play Zones</title>
                <link rel="canonical" href="https://queuebuster.co/outlet/kids-play-area" />
                <link rel="alternate" href="https://queuebuster.co/outlet/kids-play-area" hrefLang="en" />
                <meta name="description" content="Streamline your kids play area operations with QueueBuster's POS Billing Software. Easily manage entry tickets, party bookings, timed sessions, and snack counters — all in one POS." />
                <meta property="og:title" content="Make Every Play Session Seamless with QueueBuster's Kids Play Area POS" />
                <meta property="og:description" content="Manage your kids play area like a pro! QueueBuster's POS Billing Software simplifies billing, tracks sessions, and keeps your play zone running in perfect order." />
                <meta property="og:image" content="" />
                <meta property="og:url" content="https://queuebuster.co/outlet/kids-play-area" />
            </Head>
         <SchemaTags page="kids-play-area" />
            {mobileView ? <Mobile /> : <Desktop />}
        </>
    )
}



export default kidsPlayArea
